import type { Memo } from '@memori-web/shared';
import type { ApiClient } from '@memori-web/shared';
import { mergeLWW } from '@memori-web/shared';
import {
  getMemo,
  listDirtyMemos,
  markClean,
  putMemo,
} from '../storage/memosStore.js';
import { getCursor, setCursor } from '../storage/cursorStore.js';

export async function runSync(api: ApiClient): Promise<void> {
  // 1. Pull (ページネーション)
  let since = await getCursor();
  let serverTime: string | null = null;

  while (true) {
    const page = await api.pull(since);
    serverTime = page.serverTime;
    for (const r of page.memos) {
      const existing = await getMemo(r.id);
      const merged = existing ? mergeLWW(existing, r) : r;
      await putMemo(merged, { dirty: false });
    }
    if (!page.nextCursor) break;
    since = page.nextCursor;
  }

  if (serverTime) {
    await setCursor(serverTime);
  }

  // 2. Push dirty
  const dirty = await listDirtyMemos();
  if (dirty.length === 0) return;

  const payload: Memo[] = dirty.map(({ dirty: _d, ...rest }) => rest);
  const { results } = await api.push(payload);

  for (const r of results) {
    if (r.accepted) {
      await markClean(r.id);
    } else {
      // サーバ版で上書き + dirty 解除
      await putMemo(r.memo, { dirty: false });
    }
  }
}
